import { useMemo } from 'react'
import qs from 'qs'
import { useIntl, FormattedMessage } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import { unique } from 'lib/array/arrayUtils'

import useOfferList from 'hooks/Offers/useOfferList'
import { getThemeClassName } from 'lib/theme/themeUtils'
import { CRUISE_BANK_OFFERS_FILTERS, CRUISE_ONLY_FLASH_OFFER_IDS } from 'constants/cruise'

const cruiseTourCarouselFilters: App.OfferListFilters = {
  ...CRUISE_BANK_OFFERS_FILTERS,
  offerSource: 'tours',
}

const FIXED_CRUISE_TOUR_IDS = [
  'tour-759efb69-7bd2-499f-bb04-8393e16de040',
  'tour-33a81f84-b5f9-4c6c-9226-728d10b75854',
  'tour-b94e1f05-fa66-44c9-b80f-3af4e3e6d3ca',
  'tour-6d6faa33-430b-4514-8dad-c60b8a73f510',
  'tour-9c6e23ea-4930-42dc-be2d-390bfb2b77db',
  'tour-2df95adf-bb77-4b4a-8408-e59774cabe40',
  'tour-950f8f6b-dc67-4849-be70-fd90cfd6949c',
]

function CruisePageCruiseTourCarousel() {
  const intl = useIntl()
  const offerListOptions = useMemo(() => ({ excludedIds: CRUISE_ONLY_FLASH_OFFER_IDS }), [])
  const offerList = useOfferList(cruiseTourCarouselFilters, offerListOptions)

  const viewAllLabel = intl.formatMessage({
    id: 'WaDIRFn1uFiYKwi1LfxI',
    defaultMessage: 'View all',
    description: 'Button label on the Cruise Tour homepage carousel; navigates to cruise search results filtered to cruise tour products.',
  })

  const listOfferIds = useMemo(() => {
    return {
      ...offerList,
      offerIds: unique([...FIXED_CRUISE_TOUR_IDS, ...offerList.offerIds]),
    }
  }, [offerList])

  if (!listOfferIds.fetching && !listOfferIds.offerIds.length) return null

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group gap={16} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading2">
          <FormattedMessage
            id="torK3HDdDbEkeajjnh1B"
            defaultMessage="Cruise <i>tours</i>"
            description="Section heading for the Cruise Tour product carousel on the cruises vertical homepage; the word tours is rendered in italics for emphasis."
            values={{ i: (chunks) => <i>{chunks}</i> }}
          />
        </Heading>

        <TextButton
          to={`/search/cruises?${qs.stringify(cruiseTourCarouselFilters, { arrayFormat: 'repeat' })}`}
          kind="tertiary"
          variant="dark"
        >
          {viewAllLabel}
        </TextButton>
      </Group>
    </LayoutContainer>

    <OfferListCarousel
      tileStyle="card-default"
      tileSize="medium"
      overrideOfferList={listOfferIds}
      className={getThemeClassName({ desktop: 'default' })}
    />
  </Group>
}

export default CruisePageCruiseTourCarousel
